import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from 'src/utils/api';
import { IResource } from 'src/models/Resource';
import { IProjectDetails, IResourceProject } from 'src/models/Project';
import { formatDate, formatToastMsg } from 'src/utils/helpers';
import { IActivity } from 'src/models/Activity';
import en from 'src/messages/en.json';
import { setError } from 'src/redux/features/common/commonSlice';

export const fetchAllProjects: any = createAsyncThunk(
  'projects/fetchAllProjects',
  async ({}, { rejectWithValue, dispatch }) => {
    try {
      const response = await client.get(`Project`);

      return response.data;
    } catch (err) {
      dispatch(setError(en.Common.Error.fetchData));

      return rejectWithValue(err);
    }
  },
);
export const fetchAllProducts: any = createAsyncThunk(
  'projects/fetchAllProducts',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await client.get(`Project/product`);

      return response.data;
    } catch (err) {
      dispatch(setError(en.Common.Error.fetchData));

      return rejectWithValue(err);
    }
  },
);
export const fetchProjects: any = createAsyncThunk(
  'projects/fetchProjects',
  async ({ date }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await client.get(`Project/weekly/${date}`);

      return response.data;
    } catch (err) {
      dispatch(setError(en.Common.Error.fetchData));

      return rejectWithValue(err);
    }
  },
);

export const searchProjects: any = createAsyncThunk(
  'projects/searchProjects',
  async ({ query }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await client.get(`Project/search/${query}`);

      return response.data;
    } catch (err) {
      dispatch(setError(en.Timesheet.Error.fetchTimesheet));

      return rejectWithValue(err);
    }
  },
);

export const fetchAssignedProjectsByResource: any = createAsyncThunk(
  'projects/fetchAssignedProjectsByResource',
  async ({ resource }: any, { rejectWithValue, dispatch }) => {
    try {
      console.log(' resource ', resource);
      const response = await client.get(
        `Project/assigned?resource=${resource}`,
        {
          // body: { resource },
        },
      );

      return response.data as IProjectDetails[];
    } catch (err) {
      dispatch(
        setError(
          formatToastMsg(en.Projects.Error.fetchAssignedProjects, {
            resource,
          }),
        ),
      );

      return rejectWithValue(err);
    }
  },
);
export const fetchAssignedProjectsOfResource: any = createAsyncThunk(
  'projects/fetchAssignedProjectsOfResource',
  async ({ resource, date }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await client.get(
        `Project/assignedProjects?resource=${resource}&date=${date}`,
      );

      return response.data as IResourceProject[];
    } catch (err) {
      dispatch(setError(en.Projects.Error.fetchProjects));

      return rejectWithValue(err);
    }
  },
);

export const fetchProjectsById: any = createAsyncThunk(
  'projects/fetchProjectsById',
  async ({ id, skipError = false }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await client.get(`Project/${id}`, {
        // body: { resource },
      });

      const formattedData: IProjectDetails = { ...response.data };

      const resources: IResource[] = response?.data?.resources.map(
        (item: IResource, index) => {
          const resource = {
            ...item,
            id: index,
            isNewResource: false,
            startDate: formatDate(item.startDate),
            endDate: formatDate(item.endDate),
          };

          return resource;
        },
      );

      formattedData.resources = [...resources];

      return formattedData;
    } catch (err) {
      if (!skipError) {
        dispatch(setError(en.Common.Error.fetchData));
      }

      return rejectWithValue(err);
    }
  },
);

export const assignProject: any = createAsyncThunk(
  'projects/assignProject',
  async ({ payload, date }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await client.post(`Project/assign/${date}`, payload);

      return response.data;
    } catch (err) {
      dispatch(
        setError(err?.customizedMessage || en.Common.Error.updateChanges),
      );

      return rejectWithValue(err);
    }
  },
);

export const assignActivityToProject: any = createAsyncThunk(
  'projects/assignActivityToProject',
  async ({ id, payload }: any, { rejectWithValue, dispatch }) => {
    try {
      const reqObj = payload.activities.map((item: IActivity) => item);

      const response = await client.post(
        `Activity/${id}/assignActivities`,
        reqObj,
      );

      return response.data;
    } catch (err) {
      console.log('err', err);
      dispatch(setError(en.Common.Error.saveChanges));

      return rejectWithValue(err);
    }
  },
);
export const assignProduct: any = createAsyncThunk(
  'projects/assignProduct',
  async ({ productProjects }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await client.post(
        `Project/product/save`,
        productProjects,
      );

      return response.data;
    } catch (err) {
      console.log('err', err);
      dispatch(setError(en.Common.Error.saveChanges));

      return rejectWithValue(err);
    }
  },
);
export const updateProjectStatus: any = createAsyncThunk(
  'projects/updateProjectStatus',
  async ({ id, payload }: any, { rejectWithValue, dispatch }) => {
    try {
      const reqObj = payload.activities.map((item: IActivity) => item);

      const response = await client.post(
        `Project/update/ProjectResource`,
        reqObj,
      );

      return response.data;
    } catch (err) {
      console.log('err', err);
      dispatch(setError(en.Common.Error.saveChanges));

      return rejectWithValue(err);
    }
  },
);

export const fetchProjectByEmail: any = createAsyncThunk(
  'projects/fetchProjectByEmail',
  async ({ ITProjectLeaderEmail }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await client.get(
        `Project/All/${ITProjectLeaderEmail}/resources`,
      );

      return response.data;
    } catch (err) {
      console.log('err', err);
      dispatch(setError(en.Common.Error.fetchData));

      return rejectWithValue(err);
    }
  },
);

export const fetchProjectByProjectId: any = createAsyncThunk(
  'projects/fetchProjectById',
  async ({ ProjectId }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await client.get(
        `Project/${ProjectId}/programManagerResources`,
      );

      return response.data;
    } catch (err) {
      console.log('err', err);
      dispatch(setError(en.Common.Error.fetchData));

      return rejectWithValue(err);
    }
  },
);
export const revokeProgramManagerAccess: any = createAsyncThunk(
  'projects/revokeProgramManagerAccess',
  async (
    { projectId, resources, itProjectLeaderEmail }: any,
    { rejectWithValue, dispatch },
  ) => {
    try {
      const requestBody = {
        projectId,
        resources,
        itProjectLeaderEmail,
      };

      const response = await client.post(
        '/Project/revokeProgramManagerAccess',
        requestBody,
      );

      return response.data;
    } catch (err) {
      dispatch(setError(en.Access.Error.revokeAccessError));

      return rejectWithValue(err);
    }
  },
);
export const grantProgramManagerAccess: any = createAsyncThunk(
  'projects/grantProgramManagerAccess',
  async (
    { projectId, itProjectLeaderEmail, resourceEmail }: any,
    { rejectWithValue, dispatch },
  ) => {
    try {
      const requestBody = {
        projectId,
        itProjectLeaderEmail,
        resourceEmail,
      };

      const response = await client.post(
        'Project/grantProgramManagerAccess',
        requestBody,
      );

      return response.data;
    } catch (err) {
      dispatch(setError(en.Access.Error.grantAccessError));

      return rejectWithValue(err);
    }
  },
);

export enum Status {
  idle = 'idle',
  loading = 'loading',
  succeeded = 'succeeded',
  failed = 'failed',
}

const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    data: [],
    searchResults: [],
    project: {
      status: Status.idle,
      loading: false,
      data: {},
      error: '',
    },
    error: '',
    status: Status.idle,
    loading: false,
  },
  reducers: {
    resetProjects: (state) => {
      state.data = [];
      state.project = {
        status: Status.idle,
        loading: false,
        data: {},
        error: '',
      };
      state.error = '';
      state.status = Status.idle;
      state.loading = false;
    },
    resetProject: (state) => {
      state.project = {
        status: Status.idle,
        loading: false,
        data: {},
        error: '',
      };
    },
  },
  extraReducers: {
    [assignProject.pending]: (state) => {
      state.loading = true;
      state.status = Status.loading;
    },
    [assignProject.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = [action.payload];
      state.status = Status.succeeded;
    },
    [assignProject.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.status = Status.failed;
    },

    [fetchProjects.pending]: (state) => {
      state.loading = true;
      state.status = Status.loading;
    },
    [fetchProjects.fulfilled]: (state, action) => {
      state.loading = false;
      state.searchResults = action.payload;
      state.status = Status.succeeded;
    },
    [fetchProjects.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.status = Status.failed;
    },

    [searchProjects.pending]: (state) => {
      state.loading = true;
      state.status = Status.loading;
    },
    [searchProjects.fulfilled]: (state, action) => {
      state.loading = false;
      state.searchResults = action.payload;
      state.status = Status.succeeded;
    },
    [searchProjects.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.status = Status.failed;
    },
    [fetchAllProjects.pending]: (state) => {
      state.loading = true;
      state.status = Status.loading;
    },
    [fetchAllProjects.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.status = Status.succeeded;
    },
    [fetchAllProjects.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.status = Status.failed;
    },
    [fetchAllProducts.pending]: (state) => {
      state.loading = true;
      state.status = Status.loading;
    },
    [fetchAllProducts.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.status = Status.succeeded;
    },
    [fetchAllProducts.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.status = Status.failed;
    },
    [assignProduct.pending]: (state) => {
      state.loading = true;
      state.status = Status.loading;
    },
    [assignProduct.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.status = Status.succeeded;
    },
    [assignProduct.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.status = Status.failed;
    },
    [fetchAssignedProjectsByResource.pending]: (state) => {
      state.loading = true;
      state.status = Status.loading;
    },
    [fetchAssignedProjectsByResource.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.status = Status.succeeded;
    },
    [fetchAssignedProjectsByResource.rejected]: (state, action) => {
      state.loading = false;
      state.status = Status.failed;
      state.data = [];
      state.error = action.error.message;
    },
    [fetchAssignedProjectsOfResource.pending]: (state) => {
      state.loading = true;
      state.status = Status.loading;
    },
    [fetchAssignedProjectsOfResource.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.status = Status.succeeded;
    },
    [fetchAssignedProjectsOfResource.rejected]: (state, action) => {
      state.loading = false;
      state.status = Status.failed;
      state.data = [];
      state.error = action.error.message;
    },
    [fetchProjectsById.pending]: (state) => {
      state.project.loading = true;
      state.project.status = Status.loading;
    },
    [fetchProjectsById.fulfilled]: (state, action) => {
      state.project.loading = false;
      state.project.data = { ...action.payload };
      state.project.status = Status.succeeded;
    },
    [fetchProjectsById.rejected]: (state, action) => {
      state.project.loading = false;
      state.project.status = Status.failed;
      state.project.error = action.error.message;
    },
    [fetchProjectByEmail.pending]: (state) => {
      state.project.loading = true;
      state.project.status = Status.loading;
    },
    [fetchProjectByEmail.fulfilled]: (state, action) => {
      state.project.loading = false;
      state.project.data = { ...action.payload };
      state.project.status = Status.succeeded;
    },
    [fetchProjectByEmail.rejected]: (state, action) => {
      state.project.loading = false;
      state.project.status = Status.failed;
      state.project.error = action.error.message;
    },
    [fetchProjectByProjectId.pending]: (state) => {
      state.project.loading = true;
      state.project.status = Status.loading;
    },
    [fetchProjectByProjectId.fulfilled]: (state, action) => {
      state.project.loading = false;
      state.data = { ...action.payload };
      state.project.status = Status.succeeded;
    },
    [fetchProjectByProjectId.rejected]: (state, action) => {
      state.project.loading = false;
      state.project.status = Status.failed;
      state.project.error = action.error.message;
    },
    [revokeProgramManagerAccess.pending]: (state) => {
      state.loading = true;
      state.status = Status.loading;
    },
    [revokeProgramManagerAccess.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.status = Status.succeeded;
    },
    [revokeProgramManagerAccess.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.status = Status.failed;
    },
    [grantProgramManagerAccess.pending]: (state) => {
      state.loading = true;
      state.status = Status.loading;
    },
    [grantProgramManagerAccess.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.status = Status.succeeded;
    },
    [grantProgramManagerAccess.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.status = Status.failed;
    },
    [revokeProgramManagerAccess.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.status = Status.failed;
    },
  },
});

export const getProjects = (state) => {
  return {
    data: state.projects.data,
    status: state.projects.status,
    loading: state.projects.loading,
  };
};

export const getProjectsOfResource = (state) => {
  return {
    data: state.projects.data,
    status: state.projects.status,
    loading: state.projects.loading,
  };
};

export const getProjectById = (state) => {
  return {
    loading: state?.projects?.project?.loading,
    data: {
      ...state?.projects?.project?.data,
      resources: [
        ...(state?.projects?.project?.data?.resources || []).map((item) => ({
          ...item,
        })),
      ],
      activityTypes: [
        ...(state?.projects?.project?.data?.activityTypes || []).map(
          (item) => ({
            ...item,
          }),
        ),
      ],
    },
  };
};
export const fetchProjectByResourceEmail = (state) => {
  return {
    loading: state?.projects?.loading,
    data: state?.projects?.data,
  };
};

export const fetchProjectUserByProjectId = (state) => {
  return {
    loading: state?.projects?.loading,
    data: state?.projects?.data,
  };
};

export const fetchPODetalsByPONumber = (state) => {
  return {
    loading: state?.projects?.loading,
    data: state?.projects?.data,
  };
};

export const fetchDateRangeDetailByEmail = (state) => {
  return {
    loading: state?.projects?.loading,
    data: state?.projects?.data,
  };
};

const actions = projectsSlice.actions;

export { actions };
export default projectsSlice.reducer;
